import "../ShowCandidatures/styles.css";
import Data from "./Data";

export default function ShowRegistrations() {
  return (
    <div className="data_student">
      <div className="data_container">
        <Data/>
      </div>
    </div>
  );
}
